function checkpointTime(value) {
    if (!value) {
        return 0;
    }
    const normalized = String(value).trim().replace(/\//g, "-").replace(" ", "T");
    const parsed = Date.parse(normalized);
    return Number.isNaN(parsed) ? 0 : parsed;
}

export function latestCheckpoint(student) {
    const checkpoints = student && student.checkpoints;
    if (!checkpoints || checkpoints.length === 0) {
        return null;
    }
    return checkpoints.reduce((latest, item) => {
        if (!latest) {
            return item;
        }
        const latestTime = checkpointTime(latest.checkpoint_date);
        const itemTime = checkpointTime(item.checkpoint_date);
        if (itemTime > latestTime) {
            return item;
        }
        if (itemTime < latestTime) {
            return latest;
        }
        const latestId = parseInt(latest.id, 10) || 0;
        const itemId = parseInt(item.id, 10) || 0;
        return itemId >= latestId ? item : latest;
    }, null);
}
